module.exports = __webpack_public_path__ + "img/Glyphe_3.269a5e74.png";